<template>
  <Container type="card-full">
    <div slot="header">
      <el-button v-if="type === 1 || type === 2" @click="save" :loading="btnLoading">保存</el-button>
      <el-button  @click="close">关闭</el-button>
    </div>
    <div>
      <el-form :model="lebc" label-position="left" label-width="100px">
        <el-row>
          <el-col :span="7">
            <el-form-item label="商品编码">
              <el-input v-model="lebc.lebccode" :maxlength="20" :disabled="disable"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="7" style="margin-left: 80px;">
            <el-form-item label="商品条码">
              <el-input v-model="lebc.lebcbarcode" :maxlength="20" :disabled="disable"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="商品名称">
              <el-input v-model="lebc.lebcname" :maxlength="128" :disabled="disable"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="3" style="margin-left: 80px;" >
            <el-form-item label="作废" label-width="50px">
              <el-checkbox v-model="lebc.lebcinvalid"></el-checkbox>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="7">
            <el-form-item label="商品型号">
              <el-input v-model="lebc.lebcmodel" :maxlength="20" :disabled="disable"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="7" style="margin-left: 80px;">
            <el-form-item label="商品规格">
              <el-input v-model="lebc.lebcsize" :maxlength="20" :disabled="disable"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="7">
            <el-form-item label="商品分类">
              <el-select v-model="lebc.lebcletid" :clearable="true" :disabled="disable">
                <el-option v-for="(item, index) in letList" :label="item.letname" :value="item.letid" :key="index"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="7" style="margin-left: 80px;">
            <el-form-item label="计量单位">
              <el-select v-model="lebc.lebcunitid" :clearable="true" :disabled="disable">
                <el-option v-for="(item, index) in unitList" :label="item.unitname" :value="item.unitid" :key="index"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="7">
            <el-form-item label="采购价格">
              <el-input v-model="lebc.lebcpprice" :maxlength="20" :disabled="disable"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="7" style="margin-left: 80px;">
            <el-form-item label="销售价格">
              <el-input v-model="lebc.lebcsprice" :maxlength="128" :disabled="disable"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="15">
            <el-form-item label="详细说明">
              <el-input v-model="lebc.lebcremark" :maxlength="255" type="textarea" :disabled="disable"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
  </Container>
</template>

<script>
  import request from '@/utils/request'
  import utils from '../../assets/js/utils'
  export default {
    name: "lebcform",
    data () {
      return {
        lebc: this.$route.params.form,
        type: Number(this.$route.params.type),
        disable: this.$route.params.type === 3 ? true : false,
        btnLoading: false,
        letList: [],
        unitList: []
      }
    },
    created () {
    },
    activated() {
      this.init()
      this.getLetList()
      this.getUnitList()
    },
    watch: {
    },
    filters: {
    },
    methods: {
      async init() {
        this.lebc = this.$route.params.form
        this.type = Number(this.$route.params.type)
        this.disable = this.$route.params.type === 3 ? true : false
        this.btnLoading = false
        this.letList = []
        this.unitList = []
      },
      async getLetList () {
        this.letList = await request({
          method: 'get',
          url: '/basic/let/getLetEndList',
          params: {comid: this.$store.getters.loginUser.usercomid}
        })
      },
      async getUnitList () {
        this.unitList = await request({
          method: 'get',
          url: '/basic/unit/getUnitList',
          params: {}
        })
      },
      async save () {
        let model = {
          insertRecords: [],
          updateRecords: [],
          removeRecords: []
        }
        if (this.lebc.lebcid === 0) {
          model.insertRecords = [this.lebc]
        } else {
          model.updateRecords = [this.lebc]
        }
        await this.addOrEdit(model)
      },
      async addOrEdit (model) {
        if (model.insertRecords.length===0 && model.updateRecords.length === 0 && model.removeRecords.length ===0) {
          this.$message.warning('数据没有修改，不需要保存')
          return
        }
        let data = await request({
          url: '/basic/lebc/addOrEdit',
          method: "post",
          data: model
        })
        if (data.issuccess===1) {
          this.close()
          this.$message.success('保存成功')
        } else {
          this.$message.error('保存失败')
        }
      },
      close () {
        this.$store.commit('close_tab', {routeName: this.$route.name, vm: this, newRouteName: 'lebcIndex'})
      }
    }
  }
</script>

<style scoped>

</style>
